import { validateOwnerData } from 'registration/actions/validate-owner-data.actions';
import template from './chain-subordinate.html';

const mapStateToThis = ({ registration, config, dictionary, session }) => {
  const { ownerData } = registration;
  const { locale } = session;
  const terms = dictionary.terms[locale];

  const {
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    tellerIDMaxLength,
    registrationLockoutPeriodMinutes,
  } = config;

  return {
    ownerData,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    tellerIDMaxLength,
    terms,
    registrationLockoutPeriodMinutes,
  };
};

const mapDispatchToThis = {
  validateOwnerData,
};

@Inject('$ngRedux', 'Responsive')
class SelfRegistrationRetailerChainSubordinateController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.clearRegistrationForm();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async checkTeller(form) {
    const { tellerId, passcode } = form;

    if (tellerId.$pristine || passcode.$pristine) return;

    this.isLoading = true;
    await this.validateOwnerData(this.formModel);
    this.isLoading = false;

    tellerId.$setValidity('teller', this.ownerData.validTeller);
    tellerId.$setValidity('blocked', !this.ownerData.blocked);
    passcode.$setValidity('passcode', this.ownerData.validPin);
  }
}

export default class SelfRegistrationRetailerChainSubordinateComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationRetailerChainSubordinateController;
    this.bindings = {
      form: '=',
      formModel: '=',
      clearRegistrationForm: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/chain-subordinate/chain-subordinate-component.js